export default __webpack_public_path__ + "static/media/Background_00259.81829352.png";